import Splide from '@splidejs/splide';
( function( app ) {
  const COMPONENT = {
    init: function() {
      $( '.image-slider' ).each( function( index, element ) {
        const slider = new Splide( element, {
          type: 'carousel',
          gap: '1.5rem',
          autoWidth: true,
          perMove: 1,
          pagination: false,
          speed: 800,
        } );

        slider.on( 'overflow', function( isOverflow ) {
          if ( !isOverflow ) {
            slider.options = {
              arrows: isOverflow,
              pagination: isOverflow,
              drag: isOverflow,
              clones: isOverflow ? undefined : 0,
              focus: 0,
            };
            $( element ).find( '.splide-arrows-area' ).hide();
          } else {
            $( element ).find( '.splide-arrows-area' ).show();
          }
        } );
        slider.mount();
      } );

      $( '.image-slider .splide__list' ).magnificPopup( {
        delegate: 'a',
        type: 'image',
        tLoading: 'Loading image #%curr%...',
        mainClass: 'mfp-img-mobile',
        gallery: {
          enabled: true,
          navigateByImgClick: true,
          preload: [0, 1], // Will preload 0 - before current, and 1 after the current image
        },
        image: {
          tError: '<a href="%url%">The image #%curr%</a> could not be loaded.',
        },
      } );
    },
    finalize: function() {
    },
  };

  app.registerComponent( 'image-slider', COMPONENT );
} )( app );
